import { __module as e } from "../../../../_virtual/multilineRegex.js";
Object.defineProperty(t = e.exports, "__esModule", {
  value: !0
}), t.default = function (e, t) {
  var r = e.join("");
  return new RegExp(r, t);
}, e.exports = t.default, e.exports.default = t.default;
var t,
  r = e.exports;
export { r as m };